import { Mixins, Typography } from '@openfin/ui-library';
import { createGlobalStyle } from 'styled-components';

const WINDOW_WIDTH = '345px';

export const GlobalProviderStyles = createGlobalStyle`
  body {
    width: 100vw;
    height: 100vh;
    overflow: hidden;

    font: ${Typography.base};
    color: ${({ theme }) => theme.palette.textDefault};
    background-color: ${({ theme }) => theme.palette.background2};
    caret-color: ${({ theme }) => theme.palette.textDefault};
  }

  #toast-container {
    padding: 0 !important;
    margin: 0;
    overflow: hidden !important;
  }

  * {
    padding: 0;
    margin: 0;
    box-sizing: border-box;
  }

  ul,
  li {
    list-style: none;
  }

  &, * {
    ${Mixins.scrollbar.base}
  }

  .notification-center {
    width: ${WINDOW_WIDTH};
    display: flex;
    flex-flow: column;
    height: 100%;
    background-color: ${({ theme }) => theme.palette.background2};
  }

  #react-app {
    height: 100%;
  }

  .no-select {
    user-select: none;
  }

  .single-line {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    word-wrap: break-word;
  }

  @keyframes fadeIn {
    0% {
      opacity: 0;
    }

    100% {
      opacity: 1;
    }
  }

  @keyframes fadeOutRight {
    0% {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }

    100% {
      opacity: 0;
      transform: translate3d(200%, 0, 0);
      perspective: 1000;
    }
  }
`;
